// Marquee.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
const isServer = typeof window === 'undefined';

export class Marquee extends React.PureComponent {
  marqueeEle = null;
  marqueeNameEle = null;
  state = {
    shouldAnimate: false,
  };
  componentDidMount() {
    if (!isServer) {
      this.setShouldUseMarqueeAnimation();
      window.addEventListener('resize', this.setShouldUseMarqueeAnimation);
    }
  }
  componentDidUpdate(prevProps) {
    const { text, children } = this.props;
    if (text !== prevProps.text || children !== prevProps.children) {
      this.setShouldUseMarqueeAnimation();
    }
  }
  componentWillUnmount() {
    if (!isServer) {
      window.removeEventListener('resize', this.setShouldUseMarqueeAnimation);
    }
    clearTimeout(this.nextTick);
  }
  setShouldUseMarqueeAnimation = () => {
    clearTimeout(this.nextTick);
    this.nextTick = setTimeout(() => {
      if (
        this.marqueeNameEle &&
        this.marqueeEle &&
        this.marqueeNameEle?.clientWidth > this.marqueeEle?.clientWidth
      ) {
        this.setState({ shouldAnimate: true });
      } else {
        this.setState({ shouldAnimate: false });
      }
    }, 0);
  };
  setMarqueeRef = marqueeEle => {
    this.marqueeEle = marqueeEle;
    this.setShouldUseMarqueeAnimation();
  };
  setMarqueeNameRef = el => {
    this.marqueeNameEle = el;
    this.setShouldUseMarqueeAnimation();
  };
  render() {
    const { text, justify, duration, children } = this.props;
    const { shouldAnimate } = this.state;
    return (
      <StyledMarquee
        ref={this.setMarqueeRef}
        shouldAnimate={shouldAnimate}
        justify={justify}
      >
        <MarqueeName
          ref={this.setMarqueeNameRef}
          shouldAnimate={shouldAnimate}
          duration={duration}
        >
          {children || text}
        </MarqueeName>
        {shouldAnimate && (
          <MarqueeName shouldAnimate={shouldAnimate} duration={duration}>
            {children || text}
          </MarqueeName>
        )}
      </StyledMarquee>
    );
  }
}

Marquee.propTypes = {
  text: PropTypes.string,
  duration: PropTypes.number,
  justify: PropTypes.string,
  children: PropTypes.node,
};

Marquee.defaultProps = {
  text: '',
  duration: 12,
  justify: 'start',
  children: null,
};

const StyledMarquee = styled.div`
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  justify-content: ${({ shouldAnimate, justify }) =>
    shouldAnimate ? 'start' : justify};
`;

const MarqeeKeyframes = keyframes`
  from  {
   transform: translateX(0%);
  }
  to {
   transform: translateX(-100%);
  }
`;

const MarqeeAnimation = css`
  ${MarqeeKeyframes}
`;

const MarqueeName = styled.div`
  ${({ shouldAnimate, duration }) => {
    return shouldAnimate
      ? css`
          animation: ${duration}s infinite ${MarqeeAnimation} linear;
        `
      : '';
  }}
  padding-right: ${({ shouldAnimate }) => (shouldAnimate ? '16px' : '0')};
`;
export default Marquee;
